import { render, staticRenderFns } from "./recommendShop.vue?vue&type=template&id=ed537516&scoped=true"
import script from "./recommendShop.vue?vue&type=script&lang=js"
export * from "./recommendShop.vue?vue&type=script&lang=js"
import style0 from "./recommendShop.vue?vue&type=style&index=0&id=ed537516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed537516",
  null
  
)

export default component.exports